import React, { ReactNode } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css/bundle';
import './styles/carousel.scss';

interface CarouselProps {
  children: ReactNode[];
  slidesToShow: number;
  gap?: number;
  speed?: number;
  autoplay?: boolean;
  arrows?: boolean;
  dots?: boolean;
  loop?: boolean;
  fade?: boolean;
  color?: string;
}

const Carousel: React.FC<CarouselProps> = ({ children, slidesToShow, gap, speed, autoplay, arrows, dots, loop, fade, color }) => {
  return (
    <div className="slider-div-container">
      <Swiper
        modules={[Navigation, Pagination, EffectFade, Autoplay]}
        slidesPerView={slidesToShow}
        loop={loop}
        spaceBetween={gap}
        autoplay={
          autoplay
            ? {
                delay: speed,
                disableOnInteraction: false,
              }
            : undefined
        }
        mousewheel={{ forceToAxis: true }}
        effect={fade ? 'fade' : ''}
        fadeEffect={{ crossFade: true }}
        pagination={dots ? { clickable: true } : false}
        navigation={arrows}
        className={color}
      >
        {children?.map((element, index) => (
          <SwiperSlide key={`slider-${index}`}>{element}</SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Carousel;
